/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-24 19:02:57
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-27 14:23:12
 */
import Right from "@/assets/icons/right.svg";
import { Button, Divider, message, Modal } from "antd";
import { ProTable } from "@ant-design/pro-components";
import "./index.less";
import { cancelPayment, cancelSubscriptionOrder, fetchBillingHistory, reactivate } from "@/api/modules/plan";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationCircleFilled } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import noDataIcon from "@/assets/icons/billing/暂无数据@2x.png";
import noBillingImage from "@/assets/images/billing/无订阅@2x.png";
import unsubscribeIcon from "@/assets/icons/billing/取消订阅@2x.png";
import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import LoadingPage from "@/components/loading";
import { getCurrentUser } from "@/api/modules/user";
import { setCurrentUser } from "@/redux/modules/global/action";
import IconCoupon from "@/assets/icons/subscription/iconCoupon.svg";
import CouponSubscriptionModal from "./component/CouponSubscripeModal";
import DegradationModal from "./component/Degradation";
import dayjs from "dayjs";
import { BlueText } from "@/language/component";
import ProUpgradeButton from "@/pages/Subscription/Billing/component/professionalUpgradeButton";
import CancelTryUseModal from "@/pages/Subscription/Billing/component/CancelTryUse";
import { redirectHpp } from "@/components/airwallex/Hpp";
function PaymentType({ paymentType }: { paymentType: number }) {
	const { t } = useTranslation();

	switch (paymentType) {
		case 1:
			return <span>{t("billing.table.column.paymentType.monthly")}</span>;
		case 2:
			return <span>{t("billing.table.column.paymentType.upgrade")}</span>;
		case 3:
			return <span>{t("billing.table.column.paymentType.refund")}</span>;
		case 4:
			return <span>{t("billing.table.column.paymentType.once")}</span>;
		default:
			return <span>-</span>;
	}
}

function Status({ status }: { status: number }) {
	const { t } = useTranslation();

	function Dot({ color }: { color: string }) {
		return (
			<div style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: color }} />
		);
	}

	let dotColor = "";
	let statusText = "";
	switch (status) {
		case 1:
			dotColor = "#FFC107";
			statusText = t("billing.table.column.status.pending");
			break;
		case 3:
			dotColor = "#52C41A";
			statusText = t("billing.table.column.status.success");
			break;
		case 4:
			dotColor = "#FF4D4F";
			statusText = t("billing.table.column.status.failed");
			break;
		case 5:
			dotColor = "#CECECE";
			statusText = t("billing.table.column.status.canceled");
			break;
		default:
			dotColor = "#FF4D4F";
			statusText = "-";
			break;
	}

	return (
		<div>
			<div>
				<Dot color={dotColor} />
				<span style={{ marginLeft: "0.5rem" }}>{statusText}</span>
			</div>
		</div>
	);
}

function formatDate(dateString: string) {
	if (dateString === "-") {
		return "-";
	}

	const date = new Date(dateString);
	const pad = (num: number) => num.toString().padStart(2, "0");
	let year = date.getFullYear();
	let month = pad(date.getMonth() + 1); // getMonth() 返回的月份是从0开始的
	let day = pad(date.getDate());
	let hours = pad(date.getHours());
	let minutes = pad(date.getMinutes());
	let seconds = pad(date.getSeconds());

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const Billing = () => {
	const { t } = useTranslation();

	const { currentUser, currentTeam } = useSelector(state => state.global);
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(true);
	const [isOwner, setIsOwner] = useState();
	const [plan, setPlan] = useState();
	const [billingData, setBillingData] = useState();
	const [haveBilling, setHaveBilling] = useState(false);
	const [pendingPayments, setPendingPayments] = useState(null);
	const [countdownText, setCountdownText] = useState("");
	const [showCouponSubscriptionModal, setShowCouponSubscriptionModal] = useState(false);
	const [couponType, setCouponType] = useState<"subscribe" | "upgrade" | "renew">("subscribe");
	const [showDegradationModal, setShowDegradationModal] = useState(false);
	const [showDegradationTipModal, setShowDegradationTipModal] = useState(false);
	const [showCancelTryUseModal, setCancelTryUseModal] = useState(false);
	useEffect(() => {
		getCurrentUser().then(res => {
			setPlan(res.data.currentPlan);
			// setPlan({
			// 	...res.data.currentPlan,
			// 	planId: 1
			// });

			dispatch(setCurrentUser(res.data));
		});
	}, []);

	useEffect(() => {
		setIsOwner(currentTeam?.ownerId === currentUser.id);
	}, [currentTeam]);

	useEffect(() => {
		if (isOwner) {
			fetchBillingHistory().then(data => {
				if (data.code === 200) {
					setBillingData(data.data);
				} else {
					setBillingData({});
				}
				setIsLoading(false);
			});
		} else {
			setBillingData({});
			setIsLoading(false);
		}
	}, [isOwner]);

	useEffect(() => {
		setHaveBilling(billingData?.pendingPayments || billingData?.orderHistoryList?.total > 0);
		setPendingPayments(billingData?.pendingPayments);
	}, [billingData]);

	// useEffect(() => {
	// 	function startCountdown(dateString: string) {
	// 		const endTime = new Date(dateString);

	// 		const interval = setInterval(function () {
	// 			const difference = endTime - Date.now();

	// 			if (difference <= 0) {
	// 				clearInterval(interval);
	// 				setCountdownText("");

	// 				fetchBillingHistory().then(data => {
	// 					if (data.code === 200) {
	// 						setBillingData(data.data);
	// 					}
	// 				});
	// 				return;
	// 			}

	// 			const minutes = Math.floor(difference / 1000 / 60);
	// 			const seconds = Math.floor((difference / 1000) % 60);
	// 			const text = `${minutes} ${t("billing.payment.cancel.countdown.minute")} ${seconds} ${t(
	// 				"billing.payment.cancel.countdown.seconds"
	// 			)}`;
	// 			console.log(text);
	// 			setCountdownText(text);
	// 		}, 1000);
	// 		console.log("Count down function end");
	// 	}

	// 	if (pendingPayments) {
	// 		startCountdown(pendingPayments.expiredTime);
	// 	}
	// }, [pendingPayments]);

	const handleCancelTryUseSuccess = () => {
		setCancelTryUseModal(false);
		getCurrentUser().then(res => {
			setPlan(res.data.currentPlan);
			dispatch(setCurrentUser(res.data));
			if (isOwner) {
				fetchBillingHistory().then(data => {
					if (data.code === 200) {
						setBillingData(data.data);
					} else {
						setBillingData({});
					}
					setIsLoading(false);
				});
			} else {
				setBillingData({});
				setIsLoading(false);
			}
		});
	};

	const handleCouponSubscriptionSuccess = () => {
		setShowCouponSubscriptionModal(false);
		getCurrentUser().then(res => {
			setPlan(res.data.currentPlan);
			dispatch(setCurrentUser(res.data));
			if (isOwner) {
				fetchBillingHistory().then(data => {
					if (data.code === 200) {
						setBillingData(data.data);
					} else {
						setBillingData({});
					}
					setIsLoading(false);
				});
			} else {
				setBillingData({});
				setIsLoading(false);
			}
		});
	};

	const renderPlanText = () => {
		if (!plan) {
			return;
		}

		if (plan.isTrialing) {
			return (
				<div className="headerdescribe">
					<span>{t("billing.trialText", { count: plan.trialDays })}</span>
				</div>
			);
		}

		if (plan.isExpired) {
			return (
				<div className="headerdescribe">
					<span className="expired">{t("billing.expiredText")}</span>
				</div>
			);
		}

		if (!plan.isCancelAtNext) {
			return (
				<div className="headerdescribe">
					<a
						onClick={() => {
							setCouponType("renew");
							setShowCouponSubscriptionModal(true);
						}}
					>
						<img src={IconCoupon} />
						<span style={{ marginLeft: 4 }}>{t("billing.renew")}</span>
					</a>
				</div>
			);
		}
	};

	const renderPlanDDLText = () => {
		if (!plan) {
			return;
		}

		/**  */
		// if (plan.isTrialing) {
		// 	return (
		// 		<div className="headerdescribe">
		// 			<span>{t("billing.trialText", { count: dayjs().add(plan.expiredDays, "day").format("YYYY.MM.DD") })}</span>
		// 		</div>
		// 	);
		// }

		if (plan.isExpired) {
			return (
				<div className="headerdescribe">
					<span className="expired">{t("billing.expiredText")}</span>
				</div>
			);
		}

		return (
			<div className="headerdescribe">
				<span>{t("billing.plan.Expires", { time: dayjs().add(plan.expiredDays, "day").format("YYYY.MM.DD") })}</span>
			</div>
		);
	};

	const renderSubScriptionButton = () => {
		if (!isOwner) {
			return;
		}

		/** 标准版试用期显示取消试用和升级 */
		if (plan?.isTrialing && plan?.planId === 1 && plan?.trialDays > 0) {
			return (
				<div>
					<Button
						className="canaelTryButton marginRight12"
						onClick={() => {
							setCancelTryUseModal(true);
						}}
					>
						{t("billing.blank.button.cancel try")}
					</Button>
					<Button
						type="primary"
						onClick={() => {
							setShowCouponSubscriptionModal(true);
							setCouponType("upgrade");
						}}
					>
						{t("billing.plan.upgrade.button")}
					</Button>
				</div>
			);
		}
		/** 专业版试用期显示取消试用和升级 */
		if (plan?.isTrialing && plan?.planId === 2 && plan?.trialDays > 0) {
			return (
				<div>
					<Button
						className="canaelTryButton marginRight12"
						onClick={() => {
							setCancelTryUseModal(true);
						}}
					>
						{t("billing.blank.button.cancel try")}
					</Button>
					<ProUpgradeButton buttonType="primary" className="ChooseButton">
						{t("billing.plan.upgrade.button")}
					</ProUpgradeButton>
				</div>
			);
		}

		/** 标准版套餐 */
		if (plan?.planId === 1 && plan?.expiredDays > 0) {
			return (
				<div>
					<Button
						className="marginRight12"
						onClick={() => {
							setShowCouponSubscriptionModal(true);
							setCouponType("upgrade");
						}}
					>
						{t("billing.plan.upgrade.button")}
					</Button>
					<Button
						type="primary"
						onClick={() => {
							setShowCouponSubscriptionModal(true);
							setCouponType("renew");
						}}
					>
						{t("billing.blank.button.now renew")}
					</Button>
				</div>
			);
		}

		/** 专业版套餐 */
		if (plan?.planId === 2 && plan?.expiredDays > 0) {
			return (
				<div>
					<ProUpgradeButton buttonType="" className="marginRight12">
						<span>{t("billing.plan.upgrade.button")}</span>
					</ProUpgradeButton>
					<Button
						type="primary"
						onClick={() => {
							setShowCouponSubscriptionModal(true);
							setCouponType("renew");
						}}
					>
						{t("billing.blank.button.now renew")}
					</Button>
				</div>
			);
		}

		/** 企业版套餐 */
		if (plan?.planId === 3 && plan?.expiredDays > 0) {
			return (
				<div>
					<ProUpgradeButton buttonType="primary" className="ChooseButton">
						<span>{t("billing.blank.button.now renew")}</span>
					</ProUpgradeButton>
				</div>
			);
		}
	};

	const renderPlanExpiredTip = () => {
		if (plan?.expiredDays <= 7) {
			return (
				<div className="PlanWillExpired">
					<ExclamationCircleFilled color="#FB9A0E" style={{ color: "#FB9A0E", marginRight: 10 }} />
					您的套餐将在7天后到期。为避免服务中断，请尽早续订标准版或专业版套餐。如需升级至企业版套餐，请联系客服人员。
				</div>
			);
		}
	};
	const columns = [
		{
			title: t("billing.table.column.invoiceId"),
			dataIndex: "invoiceId",
			key: "invoiceId",
			width: "20%"
		},
		{
			title: t("billing.table.column.plan"),
			dataIndex: "planName",
			key: "planName",
			width: "10%",
			render: (planName: string) => <span>{t(`billing.plan.name.${planName.toLowerCase()}`)}</span>
		},
		{
			title: t("billing.table.column.amount"),
			dataIndex: "amount",
			key: "amount",
			width: "10%",
			render: (amount: string) => <span>${amount}</span>
		},
		{
			title: t("billing.table.column.paymentType"),
			dataIndex: "paymentType",
			key: "paymentType",
			width: "15%",
			render: (type: string) => <PaymentType paymentType={parseInt(type)} />
		},
		{
			title: t("billing.table.column.paymentDate"),
			dataIndex: "paymentDate",
			key: "paymentDate",
			width: "25%",
			render: (paymentDate: string) => <span>{formatDate(paymentDate)}</span>
		},
		{
			title: t("billing.table.column.status"),
			dataIndex: "status",
			key: "status",
			width: "20%",
			render: (status: number) => <Status status={status} />
		}
	];

	const myLocale = {
		emptyText: (
			<div style={{ textAlign: "center" }}>
				<img src={noDataIcon} alt="" style={{ width: "10rem" }} />
				<p style={{ fontSize: "1rem", lineHeight: "1.5rem", color: "#010101" }}>
					{!isOwner && "You do not have permission to manage billing information"}
				</p>
				<p style={{ fontSize: "0.875rem", lineHeight: "1.5rem" }}>
					{isOwner
						? t("common.no data")
						: 'Only members of your organization with the "Owner" role can manage billing information.'}
				</p>
			</div>
		)
	};

	if (isLoading) {
		return <LoadingPage />;
	}

	if (!plan && !haveBilling) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center"
				}}
			>
				<img src={noBillingImage} alt="" style={{ width: "20rem" }} />
				<span
					style={{
						fontFamily: "PingFangSC-Regular",
						color: "#010101",
						fontSize: "1rem",
						lineHeight: "1.5rem",
						marginTop: "1.5rem",
						marginBottom: "1.5rem"
					}}
				>
					{t("billing.blank.text")}
				</span>
				{isOwner && (
					<Link to={"/billing/plan"}>
						<Button style={{ width: "6rem", height: "2.5rem", backgroundColor: "#565BDD", color: "#FFF" }}>
							{t("billing.blank.button")}
						</Button>
					</Link>
				)}
			</div>
		);
	}

	return (
		<div className="billingContainer">
			{/* {renderPlanExpiredTip()} */}
			<div className="billingContent">
				<div className="billingHeader">
					<div className="headerTitle">{t("billing.title", { name: currentTeam.name })}</div>
					{/* {renderPlanText()} */}
				</div>

				{plan && (
					<div className="currentPlanPanel">
						<div className="currentPlan" style={{ opacity: plan.isExpired ? 0.4 : 1 }}>
							<div className="currentPlanHeader">
								<div className="planTitle">
									{t("billing.plan.title")}
									<span style={{ color: "#565BDD", marginLeft: "20px" }}>
										{plan.planId === 1 ? t("billing.plan.name.standard") : t("billing.plan.name.professional")}
									</span>
									{renderPlanDDLText()}
								</div>
							</div>
							<Divider style={{ marginTop: "0.75rem" }} />
							<div className="planList">
								<div className="itemList">
									<p className="planItems">
										<img src={Right} alt={""} />
										<span>{t("billing.plan.item.unlimitedProfiles")}</span>
									</p>
									<p className="planItems">
										<img src={Right} alt={""} />
										<span>{t("billing.plan.item.accounts", { limit: plan.connectedAdAccountsLimit })}</span>
									</p>
									<p className="planItems">
										<img src={Right} alt={""} />
										<span>
											{t("billing.plan.item.rule", {
												ruleLimit: plan.ruleCreationLimit,
												activeLimit: plan.ruleActivationLimit
											})}
										</span>
									</p>
									<p className="planItems">
										<img src={Right} alt={""} />
										<span>{t("billing.plan.item.ads")}</span>
									</p>
									<p className="planItems">
										<img src={Right} alt={""} />
										<span>{t("billing.plan.item.team", { limit: plan.teamSizeLimit })}</span>
									</p>
									<p className="planItems">
										<img src={Right} alt={""} />
										<span>{t("billing.plan.item.dashboard")}</span>
									</p>
									<p className="planItems">
										<img src={Right} alt={""} />
										<span>{t("billing.plan.item.rulesFrequency", { frequency: plan.ruleFrequency })}</span>
									</p>
									{/* <p className="planItems">
										<img src={Right} alt={""} />
										<span>
											{plan.planId === 1 ? t("billing.plan.item.standard.support") : t("billing.plan.item.professional.support")}
										</span>
									</p> */}
								</div>
							</div>
						</div>
						<div className="planButton">{renderSubScriptionButton()}</div>
					</div>
				)}
				{pendingPayments && (
					<div className="pendingPayments">
						<ProTable
							headerTitle={t("billing.pending.title")}
							columns={columns}
							rowKey="invoiceId"
							dataSource={[pendingPayments]}
							locale={isOwner ? undefined : myLocale}
							search={false}
							options={false}
							pagination={false}
							variant={true}
						/>
						<div className="bottom">
							{countdownText && (
								<>
									<span className="tip">
										{t("billing.payment.cancel.countdown")}
										<span className="time"> {countdownText}</span>
										{t("billing.payment.cancel.countdown.last")}
									</span>
								</>
							)}
							<Button
								className="cancel"
								onClick={() => {
									Modal.confirm({
										width: "600px",
										title: t("billing.payment.cancel.modal.title"),
										icon: null,
										content: t("billing.payment.cancel.modal.text"),
										okText: t("billing.payment.cancel.modal.ok"),
										cancelText: t("action.button.cancel"),
										okType: "danger",
										maskClosable: true,
										onOk() {
											const params = {
												id: pendingPayments.paymentDetailsId
											};
											cancelPayment(params).then(res => {
												if (res.code === 200) {
													fetchBillingHistory().then(data => {
														if (data.code === 200) {
															setBillingData(data.data);
														}
													});
												}
											});
										}
									});
								}}
							>
								{t("billing.payment.cancel.button")}
							</Button>
							<a>
								<Button
									onClick={() => redirectHpp(pendingPayments.paymentIntentId, pendingPayments.clientSecret)}
									className="pay"
								>
									{t("billing.payment.payNow.button")}
								</Button>
							</a>
						</div>
					</div>
				)}
				<div className="billingHistory">
					<ProTable
						headerTitle={t("billing.history.title")}
						columns={columns}
						rowKey="invoiceId"
						dataSource={billingData?.orderHistoryList?.list || []}
						locale={myLocale}
						search={false}
						options={false}
						variant={true}
					/>
				</div>
			</div>
			<CouponSubscriptionModal
				open={showCouponSubscriptionModal}
				type={couponType}
				onCancel={() => {
					setShowCouponSubscriptionModal(false);
				}}
				onSuccess={handleCouponSubscriptionSuccess}
				plan={plan}
			/>
			<DegradationModal
				open={showDegradationModal}
				plan={plan}
				onCancel={() => {
					setShowDegradationModal(false);
				}}
			/>

			<CancelTryUseModal
				open={showCancelTryUseModal}
				onCancel={() => setCancelTryUseModal(false)}
				onSuccess={handleCancelTryUseSuccess}
			/>
		</div>
	);
};

export default Billing;
